import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Whychoose(props) {
    return (
        <section className=" tekrevol_dark_bg  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Services">
                            <h2>Create And Run Dynamic, Feature-Rich Tools For The Web And Mobile By Our HTML5 Development Services</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>HTML5 is one of our preferred development tools because of its cross-platform compatibility. It helps us develop enhanced web standards to fulfill the promise of a high-end user experience with every project our team kickoffs.</p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Whychoose;